import { Link } from "react-router-dom";

const serviceLinks = [
  { label: "Residential Architecture", href: "/services/residential" },
  { label: "Multi-Family / Development", href: "/services/multi-family" },
  { label: "Hospitality Design", href: "/services/hospitality" },
  { label: "Renovation", href: "/services/renovation" },
];

const companyLinks = [
  { label: "About", href: "/about" },
  { label: "Projects", href: "/projects" },
  { label: "Process", href: "/process" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="px-8 lg:px-14 pt-16 pb-10">
        {/* Brand + Top */}
        <div className="mb-14 pb-14 border-b border-white/10 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div>
            <p className="font-serif font-light text-5xl lg:text-7xl tracking-[0.08em] text-white">
              STUDIO <span className="font-semibold">1323</span>
            </p>
            <p className="mt-4 text-white/50 text-sm font-light max-w-xs leading-relaxed">
              Architecture & Design — Santa Monica, California
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center px-7 py-3.5 border border-white/30 text-white text-xs tracking-[0.15em] uppercase font-medium hover:bg-white hover:text-arch-charcoal transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap self-start lg:self-auto"
          >
            Request Consultation
            <i className="ri-arrow-right-up-line ml-2 text-sm" />
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* About */}
          <div className="lg:col-span-1">
            <p className="text-white/40 text-xs tracking-[0.15em] uppercase mb-5">About</p>
            <p className="text-white/60 text-sm leading-relaxed font-light">
              Studio 1323 is a Santa Monica-based architecture firm crafting residential, multi-family, and hospitality projects with precision and vision across greater Los Angeles.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {["ri-instagram-line", "ri-linkedin-line", "ri-pinterest-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full text-white/50 hover:text-white hover:border-white/50 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="text-white/40 text-xs tracking-[0.15em] uppercase mb-5">Services</p>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <p className="text-white/40 text-xs tracking-[0.15em] uppercase mb-5">Company</p>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white/40 text-xs tracking-[0.15em] uppercase mb-5">Contact</p>
            <address className="not-italic space-y-4">
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Address</p>
                <p className="text-white/60 text-sm font-light leading-relaxed">
                  1323 Montana Avenue, Suite 200<br />Santa Monica, CA 90403
                </p>
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Phone</p>
                <a href="tel:+13105551323" className="text-white/60 text-sm font-light hover:text-white transition-colors cursor-pointer">
                  (310) 555-1323
                </a>
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Email</p>
                <a href="mailto:hello@studio1323.com" className="text-white/60 text-sm font-light hover:text-white transition-colors cursor-pointer">
                  hello@studio1323.com
                </a>
              </div>
            </address>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs font-light">
            &copy; 2026 Studio 1323. All rights reserved. Santa Monica, California.
          </p>
          <div className="flex items-center gap-6">
            {["Privacy Policy", "Terms of Use", "Sitemap"].map((item) => (
              <a key={item} href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile sticky CTA */}
      <div className="lg:hidden fixed bottom-6 right-6 z-50">
        <Link
          to="/contact"
          className="flex items-center gap-2 bg-arch-charcoal text-white px-5 py-3 text-xs tracking-[0.12em] uppercase font-medium rounded-full cursor-pointer whitespace-nowrap"
        >
          <i className="ri-chat-1-line text-sm" />
          Consult
        </Link>
      </div>
    </footer>
  );
}
